<template>
  <div class="pt-5">
    <h1>
      {{ resource.title }}
    </h1>
    <p>
      <em>Version au {{ convertLegifranceDateToDate(resource.createdAt) }}</em>
      <b-badge v-if="resource.state === STATES.VIGUEUR" variant="success" class="ml-2" pill>En Vigueur</b-badge>
      <b-badge v-else-if="resource.state === STATES.ABROGE" variant="danger" class="ml-2" pill>Abrogé</b-badge>
    </p>

    <div class="mt-5 pt-3 pl-3 pr-3 pb-3 bg-light border rounded">
      <h6 class="text-uppercase font-poppins">
        Articles
        <em>({{ articles.length }} articles)</em>
      </h6>

      <div v-for="a in articles" :key="a.id">
        <h5>
          {{ a.nature }} {{ a.num }}
          <b-badge v-if="a.state === STATES.VIGUEUR" variant="success" class="ml-2" pill>En Vigueur</b-badge>
          <b-badge v-else-if="a.state === STATES.ABROGE" variant="danger" class="ml-2" pill>Abrogé</b-badge>
        </h5>
        <p>
          <em>Version au {{ convertTimestampToDate(a.createdAt) }}</em>
        </p>

        <p v-html="a.textHtml" class="text-strikethrough" />
      </div>

      {{ articles }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { GET } from "@/store/actions";
import { BBadge } from "bootstrap-vue";

import { STATES } from "@/constants/resources";

import { convertLegifranceDateToDate, convertTimestampToDate } from "@/helpers/date";
import { ObjectToSortedArrayReverse } from "@/helpers/utils";

export default {
  name: "Resource",
  components: { BBadge },
  computed: {
    ...mapGetters("projectsResources", ["itemById"]),
    id() {
      return this.$route.params.resourceId;
    },
    resource() {
      const { id } = this;
      return this.itemById({ id });
    },
  },
  data: () => ({
    articles: [],

    isLoading: true,

    STATES,
  }),
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("projectsResources", { getResource: GET }),
    async init() {
      this.isLoading = true;

      const { id } = this;
      const result = await this.getResource({ id });
      console.log("res", result);

      const { articles } = result;
      this.articles = ObjectToSortedArrayReverse(articles, "num");

      this.isLoading = false;
    },

    convertLegifranceDateToDate,
    convertTimestampToDate,
  },
};
</script>
